<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">{{ $t("all-groups-chats") }}</div>
      <div :class="$groupsStyle.actionsContainer">
        <!-- <div title="View text details" :class="$style.infoContainer" @click="openInfoModal">
          <img :class="$style.infoIcon" :src="infoIcon" alt="info" />
        </div> -->
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsChats">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <!-- <div :class="$style.groupsList"> -->
      <div v-for="(group, index) in props.groups" :key="index" :class="$style.groupChatContainer">
        <ChatBox
          :group="group"
          :messages="group.messages"
          :user="props.user"
          :sendMessage="sendMessage"
          :title="getGroupDisplayName(group, index, t)"
          :readOnly="props.readOnly"
        />
        <!-- <div>{{ group.name }}</div>
        <div>Messages - {{ group.messages.length }}</div> -->
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/AllGroupsChatsBox.module.css";
// import globalStyles from "@/css/global.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import ChatBox from "./ChatBox.vue";
import { toast } from "vue3-toastify";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const $style = styles;
// const $globalStyle = globalStyles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsChats: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  sendMessage: {
    type: Function,
    required: true,
  },
  readOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
});

async function sendMessage(text, groupId) {
  if (!text || !text.trim()) {
    toast.error("Cannot send empty message");
    return;
  }
  if (!groupId) {
    toast.error("Invalid group for sending message");
    return;
  }
  try {
    await props.sendMessage(text, groupId);
  } catch (error) {
    console.error("Error sending message:", error);
    toast.error("Error sending message");
  }
}
</script>

<style scoped></style>
